export default __webpack_public_path__ + "static/media/image_icon.f26c4347.svg";